// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eHub2","label":"styles_label__2XWcZ"};